import { TransformApiResponseDTO } from './../../dto/api/api-response.dto';
import { AuthService } from './../../services/auth/auth.service';
import { RegisterUser } from './../../dto/auth/auth.dto';
import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  constructor(private router: Router, private authService: AuthService) {}

  registerForm = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', Validators.required),
    phone: new FormControl('', Validators.required),
    password: new FormControl('', Validators.required),
    passwordConfirmation: new FormControl('', Validators.required),
    recaptcha: new FormControl('', Validators.required)
  });

  errRegister: boolean;
  messageResponse: string;
  preloader: boolean;
  returnFormValidation: RegisterUser;
  thanksPage: boolean;
  confirmed: boolean;
  fieldTextTypePassword: boolean;
  fieldTextTypeConfirmPassword: boolean;
  siteKey :string
  size :any
  themecaptcha :any
  type :any

  async ngOnInit(): Promise<void> {
    this.size = "normal";
    this.themecaptcha = "light";
    this.type = "image";
    this.siteKey = "6LcNTUcgAAAAAMP7brHhKd9zx72oV4iNYJ98flGD";
    this.errRegister = false;
    this.preloader = false;
    this.thanksPage = false;
    this.confirmed = false;

    window.scrollTo(0, 0);
  }

  toggleFieldTextType() {
    this.fieldTextTypePassword = !this.fieldTextTypePassword;
  }

  toggleFieldTextTypeConfirm() {
    this.fieldTextTypeConfirmPassword = !this.fieldTextTypeConfirmPassword;
  }

  get validating() {
    return this.registerForm.controls;
  }

  navigated(str: string) {
    this.router.navigate([str]);
  }

  async onSubmit() {
    const dataRegister: RegisterUser = this.registerForm.value;
    if (this.registerForm.valid) {
      if (this.registerForm.value.password !== this.registerForm.value.passwordConfirmation) {
        Swal.fire('Ops!', 'Password not match', 'error');
        return;
      }

      if (String(this.registerForm.value.password).length < 8) {
        Swal.fire('Ops!', 'Password must more than 8 characters', 'error');
        return;
      }

      this.preloader = true;    
      const result = await this.registerPost(dataRegister);
      if (!result.error) {
        this.preloader = false;
        this.thanksPage = true;
        window.scrollTo(0, 0);
      } else {
        Swal.fire('Ops!', result.message, 'error');
        this.preloader = false;
        window.scrollTo(0, 0);
      }
    }else{
      if(dataRegister.recaptcha === ''){
        Swal.fire(
          'Ops!',
          'Ops! Captcha Invalid',
          'error'
        );
        return;
      }else{
        Swal.fire(
          'Ops!',
          'Ops! Username / Password Wrong!',
          'error'
        );
        return;
      }
    }
  }

  async registerPost(
    registerUser: RegisterUser
  ): Promise<TransformApiResponseDTO> {
    return new Promise(async (resolve) => {
      this.authService.registerUser(registerUser).subscribe(
        (result) => {
          const returnData = {
            error: false,
            message: result.message,
          };
          resolve(returnData);
        },
        (error) => {
          const returnData = {
            error: true,
            message: error.message,
          };
          resolve(returnData);
        }
      );
    });
  }

  confirRegister(event) {
    if (event.target.checked && this.registerForm.valid) {
      this.confirmed = true
    } else {
      const registerFormData = this.registerForm.value;
      if(registerFormData?.email ==''){
        this.confirmed = false;
      }else if(registerFormData?.name ==''){
        this.confirmed = false;
      }else if(registerFormData?.email ==''){
        this.confirmed = false;
      }else if(registerFormData?.password ==''){
        this.confirmed = false;
      }else if(registerFormData?.passwordConfirmation ==''){
        this.confirmed = false;
      }else{
        this.confirmed = true;
      }
    }
  }
}
